import { FC } from 'react';
import logo_full from '../../assets/logo_full.png';

interface ILogoFull {
  className?: string,
  height?: string
}

// TODO à supprimer, à mettre dans un header directement
const LogoFull: FC<ILogoFull> = ({ className, height }) => {
  return <img src={logo_full} alt="LogoFull" height={height} className={className} />;
}

export default LogoFull;
